module.exports = ".table-responsive {\n  margin-top: 15px;\n  overflow-x: unset;\n}\n\n.table-responsive th,\n.table-responsive tr {\n  text-align: center;\n}\n\nh3 {\n  text-transform: uppercase;\n}\n\n.action {\n  width: 10%;\n}\n\n.dropdown-menu {\n  left: unset;\n  right: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/trash-leads/trash-leads.component.css
// module id = ./src/app/trash-leads/trash-leads.component.css
// module chunks = main